<template>
  <div>
    <pro-loading v-show="company.itemScriptLoading" />
    <div ref="scriptWrapper" class="module-content">
      <component :is="module" :query="$route.query" />
    </div>
    <modalModule />
  </div>
</template>

<script>
import Loading from '@/components/loading/Loading';
import ErrorComponent from './Error';

export default {
  name: 'ProModuleWrapper',
  data() {
    return {
      company: this.$company,
      utils: this.$utils,
      error: null,
    };
  },
  computed: {
    path() {
      if (this.company.itemOpen && this.company.itemOpen.script)
        return this.company.itemOpen.script;

      return null;
    },
    module() {
      if (
        !this.path
        || this.company.itemScriptLoading
        || this.$user.isLoadingValidateSession
      ) return null;

      return () => ({
        // eslint-disable-next-line prefer-template
        component: import(/* webpackChunkName: "module_" */'@modules/' + this.path.split('.vue')[0] + '.vue'),
        loading: Loading,
        error: ErrorComponent,
        timeout: 5000,
      });
    },
  },
  /** Caso seja utilizado como uma nested route, utiliza os hooks para abrir um módulo */
  beforeRouteEnter(to, from, next) {
    // console.log('beforeRouteEnter - to', to);
    return next(vm => {
      const { module, item } = vm.getDataFromRoute(to);

      if (!module || !item) return next(to.matched[0].path);

      vm.run(module, item);
    });
  },
  beforeRouteUpdate(to, from, next) {
    /** Barra a troca de rota caso haja um script carregando */
    if (this.company.itemScriptLoading) return next(false);

    // console.log('beforeRouteUpdate - to', to);
    const { module, item } = this.getDataFromRoute(to);

    if (!module || !item) return next(to.matched[0].path);

    this.run(module, item);

    return next();
  },
  beforeRouteLeave(to, from, next) {
    /** Barra a troca de rota caso haja um script carregando */
    if (this.company.itemScriptLoading) return next(false);

    // console.log('beforeRouteLeave - to', to);
    this.$brain.closeScript(this.error);
    return next();
  },
  methods: {
    getDataFromRoute(to) {
      const { moduleId, itemId } = to.params;

      if (!moduleId || !itemId) return {};

      const module = this.company.json.module.find(i => i.id === moduleId);
      if (!module) return {};

      const item = module.item.find(i => i.id === itemId);
      if (!item) return {};

      if (!this.hasRouteAccess({ module, item })) return {};

      return { module, item };
    },
    hasRouteAccess({ module, item } = { }) {
      const isModuleAvailable = brain.user.getAvailableModules().find(m => _.get(m, 'id') === module.id);
      if (!isModuleAvailable) return false;

      const isItemAvailable = brain.user.getAvailableModuleItems(module).find(i => _.get(i, 'id') === item.id);
      if (!isItemAvailable) return false;

      return true;
    },
    run(module, item) {
      if (this.company.itemScriptLoading) return;

      brain.openModule({ module, item, changeRoute: false });
      this.error = null;
      this.company.itemScriptLoading = true;

      this.scrollWindowTo('scriptWrapper');

      /** AJUSTA OS OBJETOS (moduleOpen, itemOpen) DA COMPANY */
      this.company.updateModulesByOpenScript()
        /** CARREGA O OBJETO (currentModule) PARA MANTER A COMPATIBILIDADE COM SCRIPTS ANTIGOS */
        .then(() => this.$script.createCurrentModulePortability())
        /** EXECUTA O REMOTESQL PARA PEGAR O SQL DE DETALHAMENTO DO MESMO */
        .then(() => this.utils.remoteSqlCore.executeSql({
          sql: this.company.itemOpen.detailSql,
          connector: this.company.itemOpen.connector,
          requestSizeLimit: this.company.itemOpen.detailSqlRequestSizeLimit,
        }))
        /** REVISA O RESULTADO DO REMOTESQL */
        .then(res => this.$script.checkResultSql(res))
        /** CRIA OS OBJETOS DE RESULTADO E DE CONFIGURAÇÃO PARA OS SCRIPTS ANTIGOS */
        .then(res => this.$script.createDocumentPortability(res))
        /** FINALIZA O PROCESSO DE CARREGAMENTO DE DADOS */
        .then(() => {
          if (!(this.company.itemOpen.autoLoading === false))
            this.company.itemScriptLoading = false;
        })
        .then(() => {
          brain.openModalModule();
          this.scrollWindowTo('scriptWrapper');
        })
        .catch(err => {
          console.log('MODULE RUN - error', err);

          if (
            err.status === '#INVALID_TOKEN' // @legacy
            || err.status === '#SESSION_NOTFOUND' // @legacy
            || err.status === '#USER_TOKEN_NOTFOUND' // @legacy
            || err.status == 401
          ) return this.$brain.sessionError(this.$route.fullPath);

          this.company.itemScriptLoading = false;
          this.error = err;
          brain.closeModule();
          if (this.$route.path === '/directScript') this.$brain.sendTo404Page(this.$route.fullPath);
        });
    },

    /**
     * =======
     * Page Scroll
     * =======
     */
    scrollWindowTo(refName) {
      setTimeout(() => {
        if (!this.$refs || !this.$refs[refName]) return;

        const elm = this.$refs[refName].$el || this.$refs[refName];

        this.smoothScroll(elm);
      }, 500);
    },
    currentYPosition() {
      // Firefox, Chrome, Opera, Safari
      if (self.pageYOffset) return self.pageYOffset;
      // Internet Explorer 6 - standards mode
      if (document.documentElement && document.documentElement.scrollTop)
        return document.documentElement.scrollTop;
      // Internet Explorer 6, 7 and 8
      if (document.body.scrollTop) return document.body.scrollTop;
      return 0;
    },

    elmYPosition(elm) {
      let y = elm.offsetTop;
      let node = elm;
      while (node.offsetParent && node.offsetParent != document.body) {
        node = node.offsetParent;
        y += node.offsetTop;
      } return y;
    },

    smoothScroll(element) {
      const startY = this.currentYPosition();
      const stopY = this.elmYPosition(element) - 100;
      const distance = stopY > startY ? stopY - startY : startY - stopY;

      /* Se a distancia for muito curta, já faz o scroll normal */
      if (distance < 100) {
        window.scrollTo(0, stopY);
        return;
      }

      let speed = Math.round(distance / 100);

      if (speed > 20) speed = 20;

      const step = Math.round(distance / 25);
      let leapY = stopY > startY ? startY + step : startY - step;
      let timer = 0;

      if (stopY > startY) {
        for (var i = startY; i < stopY; i += step) {
          setTimeout(`window.scrollTo(0, ${leapY})`, timer * speed);
          leapY += step;
          if (leapY > stopY) leapY = stopY;
          timer++;
        }
        return;
      }
      for (var i = startY; i > stopY; i -= step) {
        setTimeout(`window.scrollTo(0, ${leapY})`, timer * speed);
        leapY -= step;
        if (leapY < stopY) leapY = stopY;
        timer++;
      }
      return false;
    },
  },
};
</script>

<style scoped lang="scss">
.loading {
  padding-top: 20px;
  text-align: center;
  .loading-text {
    padding-top: 8px;
  }
}

.module-content {
  padding-top: 20px;
}
</style>
